<ng-container *ngIf="isLoading">
  <div style="display: inline-block">{{ title }}</div><div style="display: inline-block"><mat-spinner style="margin-top: -15px;margin-left: 3px;" [diameter]="18"></mat-spinner></div>
</ng-container>
<ng-container *ngIf="!isLoading">
  <span [matBadgeHidden]="badgeHidden" [matBadgeColor]="badgeColor" [matBadge]="badgeText" matBadgeOverlap="false">{{title}}</span>
</ng-container>

